import type { StoreAvailabilityCheckOutcome } from './StoreAvailabilityCheckOutcome'

export function failedAvailabilityOutcome(message: () => string): StoreAvailabilityCheckOutcome {
  return {
    get message() {
      return message()
    },
    status: 'failed'
  }
}
